import { render, staticRenderFns } from "./UploadGlobalView.vue?vue&type=template&id=bfbeab44"
import script from "./UploadGlobalView.vue?vue&type=script&lang=js"
export * from "./UploadGlobalView.vue?vue&type=script&lang=js"
import style0 from "./UploadGlobalView.vue?vue&type=style&index=0&id=bfbeab44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports